import { SubmitHandler } from "react-hook-form";

import { useCoiContext } from "../contexts/Coi";
import { IClubhouseCOIData } from "../types/coi";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { updateCOI } from "../../../../../lib/api";

const useCOIHandlers = () => {
    const dispatch = useAppDispatch();
    const team = useAppSelector(selectSelectedTeam);
    const { fileList, setCoi, setFileList, methods } = useCoiContext();

    const onSubmit: SubmitHandler<IClubhouseCOIData> = async () => {
        if (fileList.length === 0) {
            dispatch(
                alertActions.error({
                    title: `No file submitted`,
                    dismissible: true,
                }),
            );
            return;
        }

        try {
            const response = await updateCOI(team!.id, fileList);

            dispatch(
                alertActions.success({
                    title: `COI uploaded successfully`,
                    dismissible: true,
                }),
            );

            setCoi(response.coi);
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: `The server encountered a problem uploading the COI.`,
                    text: "If the problem continues, please reach out to an admin.",
                    dismissible: true,
                }),
            );
        } finally {
            setFileList([]);
            methods.resetField("files");
        }
    };

    return { onSubmit };
};

export default useCOIHandlers;
